<template>
    <canvas :width="width" :height="height" :id="id">
    </canvas>
</template>

<script>
import { uuid } from "@/utils";

export default {
    name: "DashBoard",
    props: {
        name: String,
        unit: String,
        data: Number,
        maxData: Number
    },
    data() {
        return {
            width: 382,
            height: 291,
            id: uuid(10)
        }
    },
    mounted() {
        this.draw()
    },
    computed: {
        allProp() {
            let { name, unit, data, maxData } = this
            return { name, unit, data, maxData }
        }
    },
    watch: {
        allProp(newValue, oldValue) {
            this.draw()
        }
    },
    methods: {
        draw() {
            let dom = document.getElementById(this.id)
            let ctx = dom.getContext("2d")
            ctx.clearRect(0, 0, this.width, this.height)
            this.drawOutLine(ctx)
            this.drawInline(ctx)
            this.drawCenterText(ctx)
            this.drawMinMaxText(ctx)
        },
        // 绘制外圆
        drawOutLine(ctx) {
            ctx.beginPath();
            ctx.strokeStyle = "#DCDFF2"
            ctx.lineWidth = 1
            ctx.arc(this.width / 2, 191, this.width / 2, Math.PI, 2 * Math.PI);
            ctx.stroke();
        },
        // 绘制内圆
        drawInline(ctx) {
            const startArc = 0.85 * Math.PI
            const endArc = 2.15 * Math.PI
            ctx.beginPath()
            ctx.strokeStyle = "#DCDFF2"
            ctx.lineWidth = 14
            ctx.lineCap = "round"
            ctx.arc(this.width / 2, 191, this.width / 2 - 31, startArc, endArc);
            ctx.stroke();
            // 对data数字做安全验证
            let data = this.data > this.maxData ? this.maxData : this.data
            let ratio = data / this.maxData;
            let totalArc = endArc - startArc
            let current = totalArc * ratio;
            ctx.beginPath()
            ctx.strokeStyle = "#8675FF"
            ctx.arc(this.width / 2, 191, this.width / 2 - 31, startArc, startArc + current);
            ctx.stroke();
        },
        // 绘制最小值和最大值
        drawMinMaxText(ctx) {
            const magicNum = 4;
            ctx.font = "500 14px Arial, PingFangSC-Medium, PingFang SC"
            ctx.fillStyle = "#515185"
            ctx.fillText("0", 48, this.height - magicNum)

            let width = ctx.measureText(this.maxData + "").width
            let x = this.width - 50 - width / 2 // 50是右边的边距
            ctx.fillText(this.maxData + "人", x, this.height - magicNum)
        },
        // 绘制中间的文字
        drawCenterText(ctx) {
            const dataFont = "500 64px Arial, PingFangSC-Medium, PingFang SC"
            const unitFont = "500 20px Arial, PingFangSC-Medium, PingFang SC"
            const nameFont = "500 14px Arial, PingFangSC-Medium, PingFang SC"
            const marginBottom = 33 // 33为底部边距
            const gap = 17; // 数字和单位的间距

            // 测量宽度
            ctx.font = dataFont
            let dataSize = ctx.measureText(this.data + "")
            ctx.font = unitFont
            let unitSize = ctx.measureText(this.unit)
            const data_unit_width = dataSize.width + unitSize.width + gap

            // 绘制数据
            ctx.font = dataFont
            ctx.fillStyle = "#383873"
            let dataX = (this.width - data_unit_width) / 2
            let dataY = this.height - 20 - marginBottom
            ctx.fillText(this.data + "", dataX, dataY)

            // 绘制单位
            ctx.font = unitFont
            ctx.fillStyle = "#383873"
            dataX = dataX + dataSize.width + gap
            dataY = this.height - 20 - marginBottom
            ctx.fillText(this.unit + "", dataX, dataY)

            // 绘制name
            ctx.font = nameFont
            ctx.fillStyle = "#595A88"
            dataX = (this.width - data_unit_width) / 2
            dataY = this.height - 20 - marginBottom - 70
            ctx.fillText(this.name + "", dataX, dataY)
        }
    }
}
</script>

<style scoped>

</style>
